import React, { useState, useEffect } from 'react';
import { Link,Navigate } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import './produto.css'
import { api } from '../../services/api';
import ProdutoPdf from '../reports/produtos/listaprodutos';
import { vhostV1, vhostV2 } from '../funcoes';
import SweetAlert from 'react-bootstrap-sweetalert';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import { CSVLink } from 'react-csv';
import Loading from '../components/loading/Loading';
import Footer from '../components/footer/Footer';
import etiqueta from './etiqueta';
import SRI_pagination from '../components/pagination/pagination';
import ProdutoTable from './produtoTable';
import EtiquetaPDF from './EtiquetaPDF';
import EtiquetaTriPDF from './EtiquetaTri';
import customizeScrollbar from "customsb";
import FooterBar from '../footer/footerBar';
import ValorEstoquePDF from '../reports/produtos/valorestoque';
import ValorVendaPdf from '../reports/produtos/valorvenda';
import ProdutoExcel from '../reports/produtos/listaProdutosExcel';
import ValorVendaExcel from '../reports/produtos/valorVendaExcel';
import TabelaVendaPdf from '../reports/produtos/tabelaPreco';
import TabelaVendaExcel from '../reports/produtos/tabelaPrecoExcel';
import ValorEstoqueExcel from '../reports/produtos/valorVendaExcel';





function Produto() {


     const [texto,setTexto] = useState('');
     const [busca,setBusca] = useState("");
     const [produtos,setProdutos] = useState([]);
     const [sResult,setSresult] = useState(0);
     const [confirmacao,setConfirmacao] = useState(false);
     const [confirmacaoId,setConfirmacaoID] = useState('');

     const [removeLoading,setRemoveLoading] = useState(false);

     const [dCadastro1,setDcadastro1] = useState(new Date);
     const [dAlteracao1,setDalteracao1] = useState(new Date);
     const [dultCompra1,setDultcompra1] = useState(new Date);
     const [dultVenda1,setDultvenda1] = useState(new Date);

     const [usaDcadastro1,setUsaDcadastro1] = useState(false);
     const [usaDAlteracao1,setusaDalteracao1] = useState(false);
     const [usaDultCompra1,setusaDultcompra1] = useState(false);
     const [usaDultVenda1,setusaDultvenda1] = useState(false);

     const [dCadastro2,setDcadastro2] = useState(new Date);
     const [dAlteracao2,setDalteracao2] = useState(new Date);
     const [dultCompra2,setDultcompra2] = useState(new Date);
     const [dultVenda2,setDultvenda2] = useState(new Date);

     const [usaDcadastro2,setUsaDcadastro2] = useState(false);
     const [usaDAlteracao2,setusaDalteracao2] = useState(false);
     const [usaDultCompra2,setusaDultcompra2] = useState(false);
     const [usaDultVenda2,setusaDultvenda2] = useState(false);


     const [cGrupo,setCgrupo] = useState(0);
     const [cSubGrupo,setCsubGrupo] = useState(0);
     const [cLinha,setClinha] = useState(0);


     const [diferenteZero,setDiferenteZero] = useState(false);
     const [estoqueNegativo,setEstoqueNegativo] = useState(false);
     const [vendaZerada,setVendaZerada] = useState(false);
     const [prodInativo,setProdInativo] = useState(false);

     const [Itens,setItens] = useState([]);
     const [resultItens,setResultItens] = useState([]);
     const [grupos,setGrupos] = useState([]);
     const [load,setLoad] = useState(false);
     const [nPag,setnPag] = useState(1);
     const [totalPaginas,setTotalPaginas] = useState(0); 
     const [totalProdutos, setTotalProdutos] = useState(0);
     const [tpRelatorio,setTprelatorio] = useState(0);
     const [tpBusca,setTpBusca] = useState(0);
     const [selectRelatorio, setSelectRelatorio] = useState(false);
     const [tipoProd, setTipoProd] = useState('');

     function handlePageChange(value){
      if(value === "&laquo;" || value === '... '){
        setnPag(1);
      }else if (value === "&lsaquo;" ){
        if (nPag !== 1){
          setnPag(nPag -1);
        }
      }else if(value === "&rsaquo;"){
        setnPag(nPag +1);        
      }else if(value === "&raquo;" || value === ' ...' ){
        setnPag(totalPaginas);        
      }else{
        setnPag(value);
      }    
     
     }

     // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);

      

  // ROTA DE EXCLUIR PRODUTO
      function deleteUser(id){
          api.patch(vhostV1('webcash/produto/'+id), {
            loja: localStorage.getItem('loja'),
            empresa: 0        
          },config)
          .then(function (response) {
            setConfirmacao(false);
            window.location.reload();              
                    
          })
          .catch(function (error) {
            console.log(error);
            setConfirmacao(false);
            
          });
      
      }

  //buscar Grupos
  useEffect(function(){      
    api.post(vhostV1('webcash/grupos'), {
             pagina: 1,
             regPag: 1000,
             busca: busca
           },config)
      .then(function (response) {
        console.log(response);
        
        setGrupos(response.data.dados); 
        
      })
      .catch(function (error) {
        console.log(error+'erro ao listar Grupos');
                
      });

      
  },[])

  function limpaFiltros(){
    setusaDalteracao1(false);
    setusaDalteracao2(false);
    setUsaDcadastro1(false);
    setUsaDcadastro2(false);
    setusaDultcompra1(false);
    setusaDultcompra2(false);
    setusaDultvenda1(false);
    setusaDultvenda2(false);
    setEstoqueNegativo(false);
    setDiferenteZero(false);
    setVendaZerada(false);
    setProdInativo(false);
    setnPag(1);
    setTexto('');
    setBusca('');
    setDalteracao1(new Date);
    setDalteracao2(new Date); 
    setDcadastro1(new Date);
    setDcadastro2(new Date);
    setDultcompra1(new Date);
    setDultcompra2(new Date); 
    setDultvenda1(new Date);
    setDultvenda2(new Date);
    setCgrupo(0);
    setCsubGrupo(0);
    setClinha(0);
    setTipoProd('');



    setLoad(true)
    const sJson = {}
    sJson.loja=localStorage.getItem('loja'); 
    sJson.empresa=0;
    sJson.grupo=0;
    sJson.subgrupo=0;
    sJson.linha=0;
    sJson.estoque_diferente=false;
    sJson.estoque_negativo=false;
    sJson.preco_zerado=false;
    sJson.inativo=false;
    sJson.pagina= 1;
    sJson.regPag=10;
    sJson.busca= ''; 
    sJson.tipoBusca=0; 
    sJson.tipo_prod='';    
    
    console.log(sJson);
    
      api.post(vhostV1('webcash/produto/listar'),sJson,config)
        .then(function (response) {
          console.log(response);           
          setProdutos(response.data.dados); 
          setSresult(response.data.result);
          setTotalPaginas(response.data.quantidadeDePaginas);
          setTotalProdutos(response.data.quantidadeDeProdutos);
          setLoad(false);
                                      
                   
        })
        .catch(function (error) {
          setLoad(false);
          console.log(error);

                  
        });
  }


  function filtraProdutos(){
    setLoad(true)
    const sJson = {}
    sJson.loja=localStorage.getItem('loja'); 
    sJson.empresa=0;
    sJson.grupo=Number(cGrupo);
    sJson.subgrupo=cSubGrupo;
    sJson.linha=cLinha;
    if(usaDcadastro1 === true)
    { sJson.data_cadastro1=dCadastro1}
    if(usaDAlteracao1 === true)
    { sJson.data_alteracao1=dAlteracao1}
    if(usaDultCompra1 === true)
    { sJson.data_compra1=dultCompra1}
    if(usaDultVenda1 === true)
    { sJson.data_venda1=dultVenda1}
    if(usaDcadastro2 === true)
    { sJson.data_cadastro2=dCadastro2}
    if(usaDAlteracao2 === true)
    { sJson.data_alteracao2=dAlteracao2}
    if(usaDultCompra2 === true)
    { sJson.data_compra2=dultCompra2}
    if(usaDultVenda2 === true)
    { sJson.data_venda2=dultVenda2}
    sJson.estoque_diferente=diferenteZero
    sJson.estoque_negativo=estoqueNegativo;
    sJson.preco_zerado=vendaZerada;
    sJson.inativo=prodInativo;
    sJson.pagina= nPag;
    sJson.regPag=10;
    sJson.busca= busca; 
    sJson.tipoBusca=tpBusca; 
    sJson.tipo_prod=String(tipoProd);    
    
    console.log(sJson);
    
      api.post(vhostV1('webcash/produto/listar'),sJson,config)
        .then(function (response) {
          console.log(response);           
          setProdutos(response.data.dados); 
          setSresult(response.data.result);
          setTotalPaginas(response.data.quantidadeDePaginas);
          setTotalProdutos(response.data.quantidadeDeProdutos);
          setLoad(false);
                                      
                   
        })
        .catch(function (error) {
          setLoad(false);
          console.log(error);

                  
        });
         
  }

  

  

const getDadosRelatorio = async()=>{
  
  const sJson = {}
    sJson.loja=localStorage.getItem('loja'); 
    sJson.empresa=0;
    sJson.grupo=Number(cGrupo);
    sJson.subgrupo=cSubGrupo;
    sJson.linha=cLinha;
    if(usaDcadastro1 === true)
    { sJson.data_cadastro1=dCadastro1}
    if(usaDAlteracao1 === true)
    { sJson.data_alteracao1=dAlteracao1}
    if(usaDultCompra1 === true)
    { sJson.data_compra1=dultCompra1}
    if(usaDultVenda1 === true)
    { sJson.data_venda1=dultVenda1}
    if(usaDcadastro2 === true)
    { sJson.data_cadastro2=dCadastro2}
    if(usaDAlteracao2 === true)
    { sJson.data_alteracao2=dAlteracao2}
    if(usaDultCompra2 === true)
    { sJson.data_compra2=dultCompra2}
    if(usaDultVenda2 === true)
    { sJson.data_venda2=dultVenda2}
    sJson.estoque_diferente=diferenteZero
    sJson.estoque_negativo=estoqueNegativo;
    sJson.preco_zerado=vendaZerada;
    sJson.inativo=prodInativo;
    sJson.pagina=1;
    sJson.regPag=10000;
    sJson.busca= busca; 
    sJson.tipoBusca=tpBusca; 
    sJson.tipo_prod=String(tipoProd);    
    
  let response = {};
  try {
    response = await api.post(vhostV1('webcash/produto/listar'), sJson, config)
    
  } catch (error) {
    console.log(error);          
  }

  console.log(response);
  
   
  return response.data.dados;

  //setItens(response.data.dados); 
  //setResultItens(response.data.result)
  
}

async function gerarRelatorioProdutoVendas () { 
  
  
  const tItens = await getDadosRelatorio();

  
 
   ValorVendaPdf(tItens);
  

   
}


async function gerarRelatorioProduto () { 
  
  
  const tItens = await getDadosRelatorio();

  
 
   ProdutoPdf(tItens);
  

   
}

async function gerarRelatorioTabelaVenda () { 
  
  
  const tItens = await getDadosRelatorio();

  
 
   TabelaVendaPdf(tItens);
  

   
}


async function gerarRelatorioEstoque () { 
  
  
  const tItens = await getDadosRelatorio();
  
  tItens.sort((a, b) => a.ESTOQUE - b.ESTOQUE);
     
     ValorEstoquePDF(tItens);
 

   
}


async function gerarRelatorioProdutoExcel () { 
  
  
  const tItens = await getDadosRelatorio();

  
 
   ProdutoExcel(tItens);
  

   
}

async function gerarRelatorioProdutoVendasExcel () { 
  
  
  const tItens = await getDadosRelatorio();

  
 
   ValorVendaExcel(tItens);
  

   
}


async function gerarRelatorioTabelaVendaExcel () { 
  
  
  const tItens = await getDadosRelatorio();

  
 
   TabelaVendaExcel(tItens);
  

   
}

async function gerarRelatorioEstoqueExcel() {
  const tItens = await getDadosRelatorio();

  tItens.sort((a, b) => a.ESTOQUE - b.ESTOQUE);

  ValorEstoqueExcel(tItens);
}

function confirmadeleteUser(id){
   setConfirmacaoID(id);
   setConfirmacao(true);
   
}

  let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }

  //buscar 
  useEffect(function(){
    setLoad(true)
    //console.log('numero de Paniga '+nPag);
    const sJson = {}
    sJson.loja=localStorage.getItem('loja'); 
    sJson.empresa=0;
    sJson.grupo=cGrupo;
    sJson.subgrupo=cSubGrupo;
    sJson.linha=cLinha;
    if(usaDcadastro1 === true)
    { sJson.data_cadastro1=dCadastro1}
    if(usaDAlteracao1 === true)
    { sJson.data_alteracao1=dAlteracao1}
    if(usaDultCompra1 === true)
    { sJson.data_compra1=dultCompra1}
    if(usaDultVenda1 === true)
    { sJson.data_venda1=dultVenda1}
    if(usaDcadastro2 === true)
    { sJson.data_cadastro2=dCadastro2}
    if(usaDAlteracao2 === true)
    { sJson.data_alteracao2=dAlteracao2}
    if(usaDultCompra2 === true)
    { sJson.data_compra2=dultCompra2}
    if(usaDultVenda2 === true)
    { sJson.data_venda2=dultVenda2}
    sJson.estoque_diferente=diferenteZero
    sJson.estoque_negativo=estoqueNegativo;
    sJson.preco_zerado=vendaZerada;
    sJson.inativo=prodInativo;
    sJson.pagina= nPag;
    sJson.regPag=10;
    sJson.busca= busca; 
    sJson.tipoBusca=tpBusca; 
    sJson.tipo_prod=String(tipoProd);
                    
    
      api.post(vhostV1('webcash/produto/listar'),sJson,config)
        .then(function (response) {
          console.log(response);           
          setProdutos(response.data.dados); 
          setSresult(response.data.result)
          setTotalPaginas(response.data.quantidadeDePaginas);
          setTotalProdutos(response.data.quantidadeDeProdutos);
          setLoad(false);
          
                                      
                   
        })
        .catch(function (error) {
          setLoad(false);
          console.log(error);

                  
        });
  
        
      },[busca,nPag])

      async function handleRelatorioEstoque() {
        setTprelatorio(0);
        try {
            await gerarRelatorioEstoque();
        } catch (error) {
            console.error("Erro ao gerar relatório:", error);
        }
    }


    async function handleRelatorioProduto() {
      if(Number(tpRelatorio) === 0){
      try {
          await gerarRelatorioProduto();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }}else if(Number(tpRelatorio) === 1){
        try {
          await gerarRelatorioProdutoVendas();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);

      }}else if(Number(tpRelatorio) === 2){
        try {
          await gerarRelatorioTabelaVenda();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);

      }}else{
        try {
          await gerarRelatorioEstoque();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }
      }
  }

  async function handleRelatorioProdutoExcel() {
      if(Number(tpRelatorio) === 0){
      try {
          await gerarRelatorioProdutoExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }}else if(Number(tpRelatorio) === 1){
        try {
          await gerarRelatorioProdutoVendasExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);

      }}else if(Number(tpRelatorio) === 2){
        try {
          await gerarRelatorioTabelaVendaExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);

      }}else{
        try {
          await gerarRelatorioEstoqueExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }
      }
  }

  function handleDalteracaocheck(e){
    setusaDalteracao1(e.target.checked);
    setusaDalteracao2(e.target.checked);
  }
      
  function handleDcadastrocheck(e){
    setUsaDcadastro1(e.target.checked);
    setUsaDcadastro2(e.target.checked);
  }

  function handleDultCompracheck(e){
    setusaDultcompra1(e.target.checked);
    setusaDultcompra2(e.target.checked);
  }

  function handleDultVendacheck(e){
    setusaDultvenda1(e.target.checked);
    setusaDultvenda2(e.target.checked);
  }


    return <div>
               
        <Navbar/>
        <div className="container-fluid titulo offset-lg-1 col-lg-10">
        <div className='row'>
        <h1>Cadastro de Produtos</h1>
        </div>
        <hr />
        <div className="row">
        <div className="col-4 d-flex align-items-center">
  
  <Link 
    id='botao-produto' 
    to='/app/novoProduto/-1/1' 
    className="btn btn-primary btn-cli" 
    type="button">
    <i className="bi bi-plus-circle-fill"></i> Produto
  </Link>


  <button 
    id='botao-produto' 
    className="btn btn-secondary btn-cli" 
    type="button" 
    data-bs-toggle="modal" 
    data-bs-target="#staticBackdrop">
    <i className="bi bi-funnel-fill"></i> Filtros
  </button>

  <button 
    id='botao-produto' 
    className="btn btn-danger btn-cli" 
    type="button"
    onClick={() => setSelectRelatorio(true)}
    >
    <i className="bi bi-printer-fill"></i> Relatório
  </button>


  
</div>
         
            
         
          

          <div className="col-3">
            
            <select class="form-select" onChange={(e)=> setTpBusca(e.target.value)} aria-label="Default select example">
              <option value={0} selected>Qualquer parte</option>
              <option value={1}>Começando com...</option>
              <option value={2}>Finalizando com...</option>
            </select>
          </div>
                        
          <div className="modal fade mt-5" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">Filtros de Produtos</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="contnt-modal">
                  

                   <div className="row">
                        
                     <div className="datas col-3">
                        <h6>Datas Iniciais</h6>
                          <div className="form-check form-switch" >
                            <input className="form-check-input" onChange={(e) => handleDcadastrocheck(e)} checked={usaDcadastro1} type="checkbox" role="switch"  id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Cadastro</label>
                            <input type="date" value={dCadastro1} onChange={(e) => setDcadastro1(e.target.value)} className='form-control' />
                          </div>

                          <div className="form-check form-switch" >
                            <input className="form-check-input" type="checkbox" onChange={(e) => handleDalteracaocheck(e)} checked={usaDAlteracao1} role="switch" id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Alteração</label>
                            <input type="date" value={dAlteracao1} onChange={(e) => setDalteracao1(e.target.value)} className='form-control'/>
                          </div>

                          <div className="form-check form-switch" >
                            <input className="form-check-input" type="checkbox" checked={usaDultCompra1} onChange={(e) => handleDultCompracheck(e)} role="switch" id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Última Compra</label>
                            <input type="date" value={dultCompra1} onChange={(e) => setDultcompra1(e.target.value)} className='form-control'/>
                          </div>

                          <div className="form-check form-switch" >
                            <input className="form-check-input" type="checkbox" checked={usaDultVenda1} onChange={(e) => handleDultVendacheck(e)} role="switch" id="flexSwitchCheckDefault"/>
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Última Venda</label>
                            <input type="date" value={dultVenda1} onChange={(e) => setDultvenda1(e.target.value)} className='form-control'/>
                          </div>
                     </div>

                     <div className="datas col-3">
                        <h6 id='data-final-filtro'>Datas Finais</h6>
                          <div className="form-check form-switch mt-4" >
                           
                            <input type="date" value={dCadastro2} onChange={(e) => setDcadastro2(e.target.value)} className='form-control' />
                          </div>

                          <div className="form-check form-switch mt-4" >
                            <input type="date" value={dAlteracao2} onChange={(e) => setDalteracao2(e.target.value)} className='form-control'/>
                          </div>

                          <div className="form-check form-switch mt-4" >
                            
                            <input type="date" value={dultCompra2} onChange={(e) => setDultcompra2(e.target.value)} className='form-control'/>
                          </div>

                          <div className="form-check form-switch mt-4" >
                            
                            <input type="date" value={dultVenda2} onChange={(e) => setDultvenda2(e.target.value)} className='form-control'/>
                          </div>
                     </div>

                     <div className="classificacao col-3">
                      <h6>Classificação</h6>
                        <div >
                          <label className="form-select-label" htmlFor="flexCheckDefault">Grupo</label>
                          <select className="form-select" onChange={(e) => setCgrupo(e.target.value)} aria-label="Default select example">
                          <option value={0} >selecione o grupo</option>
                          {grupos.map((grupo,i) => {
                            return <option key={i} value={grupo.COD_GRUPO}>{grupo.DESCRICAO}</option>  
                          })}
                          
                        </select>
                        </div>

                        
            <div className="">
              <label htmlFor="inputState" className="form-label">
                Tipo Produto
              </label>
              <select
                id="inputUnidade"
                value={tipoProd}
                onChange={(e) => setTipoProd(e.target.value)}
                className="form-select"
                tabIndex="5"
              >
                <option value={""}>TODOS</option>
                <option value={"0"}>VENDA</option>
                <option value={"1"}>COMPOSTO</option>
                <option value={"2"}>CONSUMO</option>
                <option value={"3"}>MATERIA_PRIMA</option>
                <option value={"4"}>MIX</option>
                <option value={"5"}>CORTE</option>
              </select>
            </div>


                      
                     </div>



                     <div className="condicoes col-3">
                        <h6>Condições e Filtros</h6>
                        <br />
                        <div className="form-check">
                          <input className="form-check-input" onChange={(e) => setDiferenteZero(e.target.checked)} type="checkbox" checked={diferenteZero} id="flexCheckDefault"/>
                          <label className="form-check-label" htmlFor="flexCheckDefault">
                            Estoque dif. de zero
                          </label>
                        </div>

                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" onChange={(e) => setEstoqueNegativo(e.target.checked)} checked={estoqueNegativo} id="flexCheckDefault"/>
                          <label className="form-check-label" htmlFor="flexCheckDefault">
                            Estoque negativa
                          </label>
                        </div>

                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" onChange={(e) => setVendaZerada(e.target.checked)} checked={vendaZerada} id="flexCheckDefault"/>
                          <label className="form-check-label" htmlFor="flexCheckDefault">
                            Pr. Venda Zerado
                          </label>
                        </div>

                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" onChange={(e) => setProdInativo(e.target.checked)} checked={prodInativo} id="flexCheckDefault"/>
                          <label className="form-check-label" htmlFor="flexCheckDefault">
                            Inativos
                          </label>
                        </div>


                     </div>

                   </div>

                  </div>
                </div>
                <div className="modal-footer">
                <button type="button" onClick={limpaFiltros} className="btn btn-danger btn-cli" data-bs-dismiss="modal">Limpar</button>
                <button type="button" onClick={filtraProdutos} className="btn btn-secondary" data-bs-dismiss="modal">Ativar</button>
                  
                   { sResult === 1?
                  <div>                  
                 
                
                  </div>
                  :null} 
                  

                </div>
              </div>
            </div>
          </div>

          <div className="col-5">
            <div className="input-group mb-3">
              <input  onChange={(e) => setTexto(e.target.value)} type="text" className="form-control" placeholder="Pesquisar por nome" aria-describedby="button-addon2" />
              <button  onClick={(e) => setBusca(texto)} className="btn btn-primary" type="button" id="button-addon2">Pesquisar</button>
            </div>
          </div>
        </div>  
        
        <div className="row produtos">
          { sResult === 1?
          <>
          
          <ProdutoTable produtos={produtos}
                        
                        confirmDeleteUser={confirmadeleteUser}
                        /> 
                
              </>
            :<BuscaVazaia/>} 


        </div>

        

            <div className="row mt-5">
              <h5>Total de produtos cadastrados: {totalProdutos}</h5>
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>
           
           
          
          {
           confirmacao ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() => deleteUser(confirmacaoId)}
              onCancel={() => setConfirmacao(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir este Item!
            </SweetAlert>:null
           
          }

          {
            selectRelatorio ? 
            <SweetAlert 
             info
             title="Selecione o tipo de relatório!" 
             showCloseButton
             onConfirm={() => setSelectRelatorio(false)} 
             onCancel={() => setSelectRelatorio(false)}
             customButtons={
            <React.Fragment>
              <div className='row'>
              <div className="d-flex justify-content-center col-12 mb-2"> 
                <select className='form-select' onChange={(e) => setTprelatorio(e.target.value)}>
                  <option value={0}>Lista de Produtos</option>
                  <option value={1}>Valor de Venda</option>
                  <option value={2}>Tabela de Preço</option>
                  <option value={3}>Valor de Estoque</option>
                </select>
              </div>
              <div className="d-flex justify-content-end col-12">
        <button className="btn btn-primary mr-1 btn-lg" onClick={handleRelatorioProduto}>PDF</button>
        <button className="btn btn-success mr-1 btn-lg" onClick={handleRelatorioProdutoExcel}>Excel</button>
       
        
        </div>
        </div>
            </React.Fragment>
                             }
               >
             
           </SweetAlert>:null


          }
          
          
     
      </div> 
        
     
     
      <FooterBar />
      
    </div>
    
}


export default Produto;